import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchAllCampaigns } from "../app/api/campaign";
import { Campaign } from "../types";

export function useCampaigns() {
  return useQuery<Campaign[], Error>({
    queryKey: ["campaigns"],
    queryFn: fetchAllCampaigns,
    staleTime: 1000,
    retry: 1,
  });
}

export function useCampaign(id: string) {
  const queryClient = useQueryClient();

  const cached = queryClient.getQueryData<Campaign[]>(["campaigns"]);
  const initial = cached?.find((u) => u._id === id) ?? null;

  return useQuery<Campaign | null, Error>({
    queryKey: ["campaigns", id],
    enabled: !initial,
    initialData: initial,
    queryFn: async () => {
      const users = await fetchAllCampaigns();
      const u = users.find((u) => u._id === id);
      if (!u) throw new Error("User not found");
      return u;
    },
  });
}
